import React from 'react';
import { Skeleton, Tooltip, Typography } from '@mui/material';
import JobCountsBar from '../JobRunCountBar';
import { formatTime, twentyFourHoursAgo } from '../utils';
import { formatDistance, parseISO } from 'date-fns';
import { JobCounts } from '../../../types/flow.types';
import { EntityDetailCardSection } from '../EntityDetailCard';
import { useGlobalSettings } from '../../../app/GlobalSettingProvider';

interface Props {
  isLoading?: boolean;
  isSuccess?: boolean;
  metaCount: number;
  percentageOfJobsByStatus: JobCounts;
  timezone: string;
}

const FlowHeaderSyncRunsSection: React.FC<Props> = ({
  isLoading,
  isSuccess,
  metaCount,
  percentageOfJobsByStatus,
  timezone,
}) => {
  const formatInTimeZone = formatTime(timezone);
  const { settings } = useGlobalSettings();
  return (
    <EntityDetailCardSection data-cy="flow-header-sync-runs-section">
      <Tooltip
        title={formatInTimeZone(parseISO(twentyFourHoursAgo.toISOString()))}
      >
        <span>
          <Typography variant="overline" fontWeight={900}>
            SYNC RUNS <br />
            <small style={{ marginTop: '-13px', display: 'block' }}>
              since{' '}
              {formatDistance(
                settings.datePicker.start,
                settings.datePicker.end,
                {
                  addSuffix: true,
                },
              )}
            </small>
          </Typography>
          {isLoading && (
            <div style={{ width: '100%' }}>
              <Skeleton sx={{ bgcolor: 'white' }} variant="text" width="50%" />
              <Skeleton sx={{ bgcolor: 'white' }} variant="text" width="20%" />
              <Skeleton sx={{ bgcolor: 'white' }} variant="text" width="22%" />
              <Skeleton sx={{ bgcolor: 'white' }} variant="text" width="20%" />
            </div>
          )}
          {isSuccess && metaCount > 0 && (
            <JobCountsBar jobCounts={percentageOfJobsByStatus} />
          )}
          {isSuccess && metaCount === 0 && (
            <Typography variant="caption" color="text.secondary">
              No syncs found for this time period
            </Typography>
          )}
        </span>
      </Tooltip>
    </EntityDetailCardSection>
  );
};

export default FlowHeaderSyncRunsSection;
